import { AppIntegrationsRepository, DevicesRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['$scope', 'Util', 'DeployRestService'];

class OnlineDeploymentController {

    constructor(
        $scope, Util,
        DeployRestService,
    ) {

        this.Util = Util;
        this.$scope = $scope;
        this.DevicesRepository = DevicesRepository;
        this.DeployRestService = DeployRestService;
        this.randomNumber = Math.floor((Math.random() * 1000) + 1);

        this.app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();

        } else {

            this._deploy();

        }

    }

    _deploy() {

        this.deploying = true;

        const device = this.DevicesRepository.getById(this.$scope.inputData.deviceId);
        const deploymentPayload = {
            deviceId: device.id,
            userId: this.Util.deepFind(device, 'relationships.user.data.id'),
            appId: this.app.id,
        };

        this.DeployRestService
            .deployOnDevice(deploymentPayload)
            .then(() => {

                this.deploying = false;

            })
            .then(null, () => {

                Alert.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: `icon-${this.Util.deepFind(device, 'attributes.type')}`,
                    },
                });
                this.Util.closeModal();

            });

    }

    close() {

        this.Util.closeModal();

    }

}

class OnlineDeploymentDirective {

    constructor() {

        this.template = require('./online-deployment.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, Util, DeployRestService) =>
            new OnlineDeploymentController(
                $scope, Util,
                DeployRestService,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'OnlineDeploymentCtrl';

    }

}

_directiveDependencies.push(() =>
    new OnlineDeploymentDirective());

angular.module('directives')
    .directive('onlineDeployment', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/online-deployment/online-deployment.js